import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CommentIcon from '@wix/da-ds/pkg/Icons/Comment';
import { useReplyButtonBase } from './useReplyButtonBase';
import s from './ReplyButton.scss';
var ReplyButton = function (_a) {
    var className = _a.className, disabledOverride = _a.disabled;
    var _b = useReplyButtonBase({
        disabledOverride: disabledOverride,
    }), onClick = _b.onClick, disabled = _b.disabled;
    var t = useTranslation().t;
    return (React.createElement(PlainButtonOrLink, { className: className, onClick: onClick, "data-hook": BiDataHook.COMMENT_REPLY_BUTTON, disabled: disabled },
        React.createElement("span", { className: s['reply-with-icon'] },
            React.createElement(CommentIcon, { className: s['reply-icon'], size: IconSize.SMALLER }),
            t('comment.action.reply'))));
};
ReplyButton.displayName = 'ReplyButton';
export default ReplyButton;
//# sourceMappingURL=ReplyButton.js.map